import { useState } from "react";
import ZoomModal from "./ZoomModal";

function ImageTableView({
  images,
  selected,
  onToggle,
  onToggleAll,
  extraColumns = [],
  onSort,
  sortBy,
  sortDirection,
  idField = "id",
}) {
  const [modalImage, setModalImage] = useState(null);

  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Media URL</th>
            <th>Media</th>
            <th className="d-flex align-items-center justify-content-between">
              <span>Select</span>
              <input
                className="form-check-input"
                type="checkbox"
                checked={
                  images.length > 0 &&
                  images.every((img) => selected.includes(img[idField]))
                }
                onChange={() => onToggleAll(images.map((img) => img[idField]))}
              />
            </th>
            {extraColumns.map((col, index) => (
              <th
                key={`extra-th-${index}`}
                onClick={() => col.sortable && onSort?.(col.key)}
                style={{ cursor: col.sortable ? "pointer" : "default" }}
                className="text-center align-middle"
              >
                {col.header}
                {col.sortable && sortBy === col.key && (
                  <span className="ms-1">
                    {sortDirection === "asc" ? "\u25B2" : "\u25BC"}
                  </span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {images.map((img) => (
            <tr key={img[idField]}>
              <td>
                <a href={img.image_url}>{img.image_url}</a>
              </td>
              <td>
                <img
                  loading="lazy"
                  src={img.image_url}
                  alt={img.label}
                  width="100"
                  style={{ cursor: "pointer" }}
                  onClick={() => setModalImage(img.image_url)}
                />
              </td>
              <td className="text-center align-middle">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selected.includes(img[idField])}
                    onChange={() => onToggle(img[idField])}
                  />
                </div>
              </td>
              {extraColumns.map((col, index) => (
                <td className="text-center align-middle" key={`extra-td-${index}`}>
                  {col.render(img)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {modalImage && (
        <ZoomModal imageUrl={modalImage} onClose={() => setModalImage(null)} />
      )}
    </div>
  );
}

export default ImageTableView;
